import React, { Component } from 'react';
import { Button } from 'antd';
import styled from "styled-components"
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Div=styled.div`
  padding: 20px;
  &:after{
    content: "";
    display: table;
    clear: both;
  }
`

const AddButton=styled(Button)`
  float:left;
  margin-right:20px;
`

class Filter extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {t,filterChange,initDialog}=this.props
    return (
      <Div>
          {/* <Select defaultValue={0} style={{width:250}} onChange={(value)=>{filterChange('type',value)}}>
              <Option value={0}>{t("运营商")}</Option>
              <Option value={1}>{t("代理")}</Option>
          </Select> */}
          <AddButton type="primary" onClick={initDialog}>{t('Upload IMEI')}</AddButton>
      </Div>
    )
  }
}

const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(Filter));